import { SequenceWaaS } from '@0xsequence/waas';

const projectAccessKey =
  import.meta.env.VITE_SEQUENCE_PROJECT_ACCESS_KEY ||
  'AQAAAAAAAKqbF7tvWjYTHAGtpi9kiQjXZdI';
const waasConfigKey =
  import.meta.env.VITE_SEQUENCE_WAAS_CONFIG_KEY ||
  'eyJwcm9qZWN0SWQiOjQzNjc1LCJycGNTZXJ2ZXIiOiJodHRwczovL3dhYXMuc2VxdWVuY2UuYXBwIn0=';

// Initialize Sequence WaaS SDK
export const sequenceWaaS = new SequenceWaaS({
  projectAccessKey,
  waasConfigKey,
  network: 'polygon', // Using Polygon as per your config
});

// Export singleton instance
export default sequenceWaaS;
